import type { AlertVariant } from 'ui/components/Alert/Alert'

export type FiredAlert = {
  alertKey?: string
  variant: AlertVariant
  /** Epoch milliseconds. */
  at: number
}

declare global {
  interface Window {
    /**
     * Read by aurora-e2e against staging, which runs the production build, so it must not be
     * gated to development.
     */
    __e2eAlerts: FiredAlert[]
  }
}

const FIRED_ALERT_LOG_LIMIT = 50

window.__e2eAlerts = []

/** Appends an alert to `window.__e2eAlerts`, dropping the oldest entry past the cap. */
export function recordFiredAlert(entry: FiredAlert): void {
  const log = window.__e2eAlerts
  log.push(entry)
  if (log.length > FIRED_ALERT_LOG_LIMIT) log.shift()
}
